module.exports = __webpack_public_path__ + "static/press-550ed022b1924a943c19743beeeea1bb.png";